const LegalFooterSignUp = () => {
  return (
    <div className="legal-footer">
      By creating an account, you accept the{" "}
      <a
        href="https://manta.app/legal/terms-of-use"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Use
      </a>{" "}
      and{" "}
      <a
        href="https://manta.app/legal/privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
    </div>
  );
};

export default LegalFooterSignUp;
